import { Lock } from "lucide-react";
import { SealDialog } from "./SealDialog";

export const BenchProgress = ({ count, target, onSeal }) => {
  const pct = Math.min(100, Math.round((count / target) * 100));
  return (
    <section data-testid="bench-progress" className="border border-cyan-400/20 bg-slate-950/70 p-5">
      <p className="lab-label">Vocabulary programmed</p>
      <p className="mt-1 font-display text-4xl font-black text-emerald-300 glow-emerald">
        <span data-testid="bench-count">{count}</span>
        <span className="text-xl text-slate-500"> / {target}</span>
      </p>
      <div className="mt-4 h-3 w-full bg-slate-800/80">
        <div className="h-full meter-on transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <p data-testid="bench-remaining" className="mt-2 font-mono text-xs tracking-widest text-slate-500">
        {count >= target ? "TARGET REACHED - READY TO SEAL" : `${target - count} MORE TO REACH TARGET`}
      </p>
      <SealDialog
        count={count}
        target={target}
        onSeal={onSeal}
        trigger={
          <button data-testid="seal-button" disabled={count === 0} className="lab-btn-primary mt-5 w-full justify-center">
            <Lock size={16} /> Seal vocabulary &amp; begin experiment
          </button>
        }
      />
      <p className="mt-2 text-center text-xs text-slate-500">You can seal at any count - 50 is the target, not a limit.</p>
    </section>
  );
};
